export default "__VITE_ASSET__CyHcVlh0__"